import { render, staticRenderFns } from "./ShowInformation.vue?vue&type=template&id=70a34ed8&scoped=true"
import script from "./ShowInformation.vue?vue&type=script&lang=js"
export * from "./ShowInformation.vue?vue&type=script&lang=js"
import style0 from "./ShowInformation.vue?vue&type=style&index=0&id=70a34ed8&prod&lang=stylus&scoped=true"
import style1 from "./ShowInformation.vue?vue&type=style&index=1&id=70a34ed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a34ed8",
  null
  
)

export default component.exports